import { useContext } from 'react';
import { BioContext } from 'contexts/bio_context';

const useBio = () => {
    return useContext(BioContext);
};

export default useBio;
